module.exports = __webpack_public_path__ + "953b6ee18ce221287cf8ef6d1e423102.png";